import { Folder, Permission } from '@nextcloud/files';
import { generateOcsUrl, generateRemoteUrl, generateUrl } from '@nextcloud/router';
import { getCurrentUser } from '@nextcloud/auth';
import axios from '@nextcloud/axios';
import { STORAGE_STATUS } from '../utils/credentialsUtils';
export const rootPath = `/files/${getCurrentUser()?.uid}`;
const entryToFolder = (ocsEntry) => {
    const path = (ocsEntry.path + '/' + ocsEntry.name).replace(/^\//gm, '');
    return new Folder({
        id: ocsEntry.id,
        source: generateRemoteUrl('dav' + rootPath + '/' + path),
        root: rootPath,
        owner: getCurrentUser()?.uid || null,
        permissions: ocsEntry.config.status !== STORAGE_STATUS.SUCCESS
            ? Permission.NONE
            : ocsEntry?.permissions || Permission.READ,
        attributes: {
            displayName: path,
            ...ocsEntry,
        },
    });
};
export const getContents = async () => {
    const response = await axios.get(generateOcsUrl('apps/files_external/api/v1/mounts'));
    const contents = response.data.ocs.data.map(entryToFolder);
    return {
        folder: new Folder({
            id: 0,
            source: generateRemoteUrl('dav' + rootPath),
            root: rootPath,
            owner: getCurrentUser()?.uid || null,
            permissions: Permission.READ,
        }),
        contents,
    };
};
export const getStatus = function (id, global = true) {
    const type = global ? 'userglobalstorages' : 'userstorages';
    return axios.get(generateUrl(`apps/files_external/${type}/${id}?testOnly=false`));
};
